/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_ButtonInputs */



/**
* | output |
* | --- |
* | "Export Audio" |
*
* @param {Audio_Description_Export_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_button = /** @type {((inputs?: Audio_Description_Export_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter l'audio")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audio exportieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esporta audio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт аудио")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportar audio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出音频")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオをエクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो निर्यात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportar áudio")
	return /** @type {LocalizedString} */ ("Export Audio")
});